import { RequestTypeDetailQuery } from 'generated/resources/graphql'

interface GetFeatureFlagsResult {
  isProcurementV2FeatureEnabled: boolean
}

export function getFeatureFlags(data?: RequestTypeDetailQuery): GetFeatureFlagsResult {
  const isProcurementV2FeatureEnabled = !!data?.features?.featuresConnection?.nodes?.some(
    (f) => f.name === 'procurement_v2' && f.enabled
  )

  return { isProcurementV2FeatureEnabled }
}
